import { RoutesPath } from 'src/types'
import { useLocales } from 'src/contexts'

import { useNavigation } from 'src/hooks/useNavigation'
import { useManageUserCars } from 'src/hooks/useManageUserCars'

export const useMyCars = () => {
  const { translations } = useLocales()
  const { navigateTo } = useNavigation()

  const { userCars, isLoadingGetCars, isLoadingSetActiveCar } =
    useManageUserCars()

  const gotoAddCar = (): void => {
    navigateTo(RoutesPath.FILL_AUTO_INFO)
  }

  const breadcrumbItems = [
    { labelKey: translations.breadcrumbItems.home, href: '/' },

    { labelKey: translations.breadcrumbItems.myCars },
  ]

  return {
    locale: translations.myCars,
    breadcrumbItems,
    userCars: userCars || [],
    isLoadingGetCars: isLoadingGetCars || isLoadingSetActiveCar,
    gotoAddCar,
  }
}
